import React, { useState, useRef, useEffect, useContext } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config"; // adjust path if needed
import { ContextBoard } from "../../context/ContextBoard";
function Studentcorrection() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryAdminToken");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  // Redirect if token missing
  useEffect(() => {
    if (!permissions[9]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);
  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    }
  }, []);
  const [loading, setLoading] = useState(false);
  // ---------------------------
  // Registration Number States
  // ---------------------------
  const [reg1, setReg1] = useState("");
  const [reg2, setReg2] = useState("");
  const [reg3, setReg3] = useState("");

  const input1Ref = useRef(null);
  const input2Ref = useRef(null);
  const input3Ref = useRef(null);

  // Full registration number format: XXXXX-XXXXX-XX
  const fullRegNo = `${reg1}-${reg2}-${reg3}`;

  // Handler for inputs
  const handleInputChange = (setter, maxLength, nextRef) => (e) => {
    const value = e.target.value.replace(/\D/g, ""); // allow only digits

    if (value.length <= maxLength) {
      setter(value);

      // Auto focus to next input
      if (value.length === maxLength && nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  // Backspace focus return
  const handleBackspace = (value, prevRef) => (e) => {
    if (e.key === "Backspace" && value.length === 0 && prevRef?.current) {
      prevRef.current.focus();
    }
  };

  // ----------------------------------------------------------------------
  // API CALL ON SEARCH
  // ----------------------------------------------------------------------
  const handleSearch = async (e) => {
    e.preventDefault();

    if (reg1.length !== 5 || reg2.length !== 5 || reg3.length !== 2) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Registration Number",
        text: "Please enter exactly 5 + 5 + 2 digits.",
      });
      return;
    }

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Unauthorized",
        text: "Please login again.",
      });
      navigate("/secondary-admin");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL2}/FetchDataStudentRegistrationByRegNo_CL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            registratioN_NO: fullRegNo, // SEND IN REQUIRED FORMAT
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        // Pass entire data to next page
        navigate("/secondary-demographic-details-update-page", {
          state: { studentData: data.data.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text:
            data.message || "No student found with this registration number.",
        });
        setLoading(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" /> Student Demographic
                      Details Correction for Class X
                    </h1>
                    <ol className="breadcrumb">
                      <li>
                        <a
                          onClick={() => navigate("/secondary-admin-dashboard")}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: 5 }}
                          ></i>
                          Home
                        </a>
                      </li>
                      <li className="active">Student Correction for Class X</li>
                    </ol>
                  </section>
                </div>
              </div>

              {/* ------------------ SEARCH SECTION ------------------ */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* Registration No Inputs */}
                      <div className="col-md-3">
                        <label className="mb-2">Registration Number</label>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                          }}
                        >
                          {/* 5 digit field 1 */}
                          <input
                            ref={input1Ref}
                            type="text"
                            className="form-control form-control-xs"
                            maxLength={5}
                            value={reg1}
                            onChange={handleInputChange(setReg1, 5, input2Ref)}
                            onKeyDown={handleBackspace(reg1, null)}
                          />
                          <div>-</div>

                          {/* 5 digit field 2 */}
                          <input
                            ref={input2Ref}
                            type="text"
                            className="form-control form-control-xs"
                            maxLength={5}
                            value={reg2}
                            onChange={handleInputChange(setReg2, 5, input3Ref)}
                            onKeyDown={handleBackspace(reg2, input1Ref)}
                          />
                          <div>-</div>

                          {/* 2 digit field */}
                          <input
                            ref={input3Ref}
                            type="text"
                            className="form-control form-control-xs"
                            maxLength={2}
                            value={reg3}
                            onChange={handleInputChange(setReg3, 2, null)}
                            onKeyDown={handleBackspace(reg3, input2Ref)}
                          />
                        </div>
                      </div>

                      {/* Search Button */}
                      <div className="col-md-1">
                        <button
                          className="btn btn-primary"
                          style={{ marginTop: "10px" }}
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search"></i> Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Studentcorrection;
